module.exports = __webpack_public_path__ + "img/safeNum.c7b2d243.png";